(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalized-bundle"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    // Clear cart when page loads
  (async function() {
    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log('Cart cleared on page load');
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  })();
  
  const maxProducts = 6;
  let selectedProducts = [];

  const discountTiers = {
  1: { percent: 0, multiplier: 1, code: '' }, // sin descuento para el primero
  2: { percent: 10, multiplier: 0.90, code: 'BUNDLE-DISCOUNT-10' },
  3: { percent: 15, multiplier: 0.85, code: 'BUNDLE-DISCOUNT-15' },
  4: { percent: 20, multiplier: 0.80, code: 'BUNDLE-DISCOUNT-20' },
  5: { percent: 25, multiplier: 0.75, code: 'BUNDLE-DISCOUNT-25' },
  6: { percent: 30, multiplier: 0.70, code: 'BUNDLE-DISCOUNT-30' }
};


  function createSpinner() {
    const spinner = document.createElement('div');
    spinner.className = 'spinner';
    spinner.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20"><path d="M10 3.5C6.41 3.5 3.5 6.41 3.5 10c0 .414-.336.75-.75.75s-.75-.336-.75-.75C2 5.582 5.582 2 10 2s8 3.582 8 8-3.582 8-8 8c-.414 0-.75-.336-.75-.75s.336-.75.75-.75c3.59 0 6.5-2.91 6.5-6.5S13.59 3.5 10 3.5z" fill="currentColor"/></svg>`;
    return spinner;
  }

  async function removeFromCart(variantId) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    });
    return response.ok;
  }

  async function updateDiscountCode() {
    const tier = Math.min(selectedProducts.length, maxProducts);
    const discountCode = selectedProducts.length > 0 ? discountTiers[tier].code : null;

    if (discountCode) {
      sessionStorage.setItem('bundle_discount_code', discountCode);
    } else {
      sessionStorage.removeItem('bundle_discount_code');
    }
  }

  document.querySelectorAll('.add-to-crate').forEach(button => {
    button.addEventListener('click', async function () {
      const originalText = this.textContent;
      const productItem = this.closest('.best-seller-item');
      const productId = productItem.dataset.productId;
      const variantId = productItem.dataset.variantId;
      const productTitle = productItem.dataset.productTitle;
      const productPrice = parseFloat(productItem.dataset.productPrice);
      const productImage = productItem.dataset.productImage;

      const spinner = createSpinner();
      this.innerHTML = '';
      this.appendChild(spinner);
      this.disabled = true;

      try {
        const existingIndex = selectedProducts.findIndex(p => p.id === productId);

        if (existingIndex >= 0) {
          await removeFromCart(selectedProducts[existingIndex].variantId);
          selectedProducts.splice(existingIndex, 1);
          this.textContent = 'Add';
          this.classList.remove('added');
        } else {
          if (selectedProducts.length >= maxProducts) {
            alert(`Maximum ${maxProducts} products allowed`);
            this.textContent = originalText;
            this.disabled = false;
            return;
          }

          const position = selectedProducts.length + 1;
          const tier = Math.min(position, maxProducts);
          const discount = discountTiers[tier];
          const discountedPrice = (productPrice * discount.multiplier).toFixed(2);

          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1
              }]
            })
          });

          const result = await addResponse.json();
          if (addResponse.ok && !result.status && !result.message) {
console.log('🧪 Response from /cart/add.js:', result);

            document.querySelector(".add-to-cart").removeAttribute('disabled');
            selectedProducts.push({
              id: productId,
              variantId: variantId,
              title: productTitle,
              originalPrice: productPrice,
              finalPrice: parseFloat(discountedPrice),
              discountPercent: discount.percent,
              image: productImage,
              position,
              discountCode: discount.code
            });

            this.textContent = 'Added';
            this.classList.add('added');
          } else {
            throw new Error('Failed to add to cart');
          }
        }

        await updateDiscountCode();
        updateUI();
      } catch (error) {
        console.error('Error:', error);
        alert('Error adding product to cart. Please try again.');
        this.textContent = originalText;
      } finally {
        this.disabled = false;
        if (this.querySelector('.spinner')) {
          this.querySelector('.spinner').remove();
          this.textContent = originalText;
        }
      }
    });
  });

  function updateUI() {
    updateProductBadges();
    updateSelectedProductsList();
  }

function updateProductBadges() {
  const total = selectedProducts.length;

  document.querySelectorAll('.best-seller-item').forEach(item => {
    const priceElement = item.querySelector('.price');
    const productPrice = parseFloat(priceElement.textContent.replace(/[^0-9.]/g, ''));

    // Buscar o crear el badge
    let badgeElement = item.querySelector('.discount-badge');
    if (!badgeElement) {
      badgeElement = document.createElement('span');
      badgeElement.className = 'discount-badge';
      priceElement.parentNode.appendChild(badgeElement);
    }

    if (total < 2) {
      // Oculta si no hay descuento
      badgeElement.style.display = 'none';
    } else {
      // Usa el mismo descuento para todos
      const tier = discountTiers[total] || discountTiers[1];
      const savings = productPrice - (productPrice * tier.multiplier);
      badgeElement.textContent = `Save $${savings.toFixed(2)} (${tier.percent}% off)`;
      badgeElement.style.display = 'inline-block';
    }
  });
}



function updateSelectedProductsList() {
  const totalSelected = selectedProducts.length;
  const countElement = document.querySelector('.selected-count');
  countElement.textContent = `${totalSelected}/6 products selected`;

  const tier = discountTiers[totalSelected] || discountTiers[1];
  const skeletonSlots = document.querySelectorAll('.product-skeleton');

  skeletonSlots.forEach((slot, index) => {
    const product = selectedProducts[index];

    if (product) {
      const discountText = totalSelected >= 2 ? `${tier.percent}% Off` : '';
      slot.classList.add('filled');
      slot.innerHTML = `
        <div class="product-info">
          <div class="product_inf_media">
            <img src="${product.image}" alt="${product.title}">
          </div>
          <div class="product_inf_det">
            <span class="product-name">${product.title}</span>
            <div class="price-container">
              ${discountText ? `<span class="savings">${discountText}</span>` : ''}
            </div>
          </div>
        </div>
        <button class="remove-product" data-product-id="${product.id}">×</button>
      `;
    } else {
      slot.classList.remove('filled');
      slot.innerHTML = `
        <div class="skeleton-content">
          <div class="skeleton-image"></div>
          <div class="skeleton-text"></div>
        </div>
      `;
    }
  });

  // Attach removal logic just once
  document.querySelectorAll('.remove-product').forEach(button => {
    button.addEventListener('click', async function () {
      const productId = this.dataset.productId;
      const product = selectedProducts.find(p => p.id === productId);
      if (!product) return;

      this.disabled = true;
      this.textContent = '...';

      try {
        await removeFromCart(product.variantId);
        selectedProducts = selectedProducts.filter(p => p.id !== productId);
        await updateDiscountCode();
        updateUI();
      } catch (error) {
        console.error('Error removing product:', error);
        alert('Error removing product. Please try again.');
      }
    });
  });
}



  // ✅ Redirect to checkout with proper discount
  document.querySelector('.crate-actions .add-to-cart')?.addEventListener('click', function () {
    const discountCode = sessionStorage.getItem('bundle_discount_code');
    if (discountCode) {
      window.location.href = `/checkout?discount=${discountCode}`;
    } else {
      window.location.href = '/checkout';
    }
  });
});
// 

  document.addEventListener("DOMContentLoaded", function () {
  const MAX_BUNDLE_ITEMS = 5;
  const addToCartBtn = document.querySelector(".add-to-cart");
  const resetBtn = document.querySelector(".reset-crate");
  const toast = document.querySelector(".toast-message");

  const productSelectors = document.querySelectorAll(".product-selector");
  const selectedProducts = new Map(); // productId -> quantity

  function updateCartState() {
    const totalQty = Array.from(selectedProducts.values()).reduce((sum, qty) => sum + qty, 0);

    if (totalQty >= MAX_BUNDLE_ITEMS) {
      addToCartBtn.removeAttribute("disabled");
    } else {
      addToCartBtn.setAttribute("disabled", "true");
    }

    // Disable selectors if bundle is full
    productSelectors.forEach((selector) => {
      const productId = selector.dataset.productId;
      const isSelected = selectedProducts.has(productId);
      if (totalQty >= MAX_BUNDLE_ITEMS && !isSelected) {
        selector.querySelector("input").setAttribute("disabled", "true");
      } else {
        selector.querySelector("input").removeAttribute("disabled");
      }
    });
  }

  function showToast(message) {
    toast.textContent = message;
    toast.style.display = "block";
    toast.style.opacity = "1";
    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => (toast.style.display = "none"), 300);
    }, 2000);
  }

  productSelectors.forEach((selector) => {
    const input = selector.querySelector("input");
    const productId = selector.dataset.productId;

    input.addEventListener("input", (e) => {
      const qty = parseInt(e.target.value, 10) || 0;
      const totalQty = Array.from(selectedProducts.values()).reduce((sum, val) => sum + val, 0);
      const currentQty = selectedProducts.get(productId) || 0;
      const newTotal = totalQty - currentQty + qty;

      if (newTotal > MAX_BUNDLE_ITEMS) {
        input.value = currentQty; // revert input
        showToast("Bundle is full already");
        return;
      }

      if (qty > 0) {
        selectedProducts.set(productId, qty);
      } else {
        selectedProducts.delete(productId);
      }

      updateCartState();
    });
  });

  resetBtn.addEventListener("click", () => {
    selectedProducts.clear();
    productSelectors.forEach((selector) => {
      const input = selector.querySelector("input");
      input.value = "0";
      input.removeAttribute("disabled");
    });
    addToCartBtn.setAttribute("disabled", "true");
  });
document.addEventListener("DOMContentLoaded", function () {
  const MAX_BUNDLE_ITEMS = 5;
  const addToCartBtn = document.querySelector(".add-to-cart");
  const resetBtn = document.querySelector(".reset-crate");
  const toast = document.querySelector(".toast-message");

  const productSelectors = document.querySelectorAll(".product-selector");
  const selectedProducts = new Map(); // productId -> quantity

  function updateCartState() {
    const totalQty = Array.from(selectedProducts.values()).reduce((sum, qty) => sum + qty, 0);

    if (totalQty >= MAX_BUNDLE_ITEMS) {
      addToCartBtn.removeAttribute("disabled");
    } else {
      addToCartBtn.setAttribute("disabled", "true");
    }

    // Disable selectors if bundle is full
    productSelectors.forEach((selector) => {
      const productId = selector.dataset.productId;
      const isSelected = selectedProducts.has(productId);
      if (totalQty >= MAX_BUNDLE_ITEMS && !isSelected) {
        selector.querySelector("input").setAttribute("disabled", "true");
      } else {
        selector.querySelector("input").removeAttribute("disabled");
      }
    });
  }

  function showToast(message) {
    toast.textContent = message;
    toast.style.display = "block";
    toast.style.opacity = "1";
    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => (toast.style.display = "none"), 300);
    }, 2000);
  }

  productSelectors.forEach((selector) => {
    const input = selector.querySelector("input");
    const productId = selector.dataset.productId;

    input.addEventListener("input", (e) => {
      const qty = parseInt(e.target.value, 10) || 0;
      const totalQty = Array.from(selectedProducts.values()).reduce((sum, val) => sum + val, 0);
      const currentQty = selectedProducts.get(productId) || 0;
      const newTotal = totalQty - currentQty + qty;

      if (newTotal > MAX_BUNDLE_ITEMS) {
        input.value = currentQty; // revert input
        showToast("Bundle is full already");
        return;
      }

      if (qty > 0) {
        selectedProducts.set(productId, qty);
      } else {
        selectedProducts.delete(productId);
      }

      updateCartState();
    });
  });

  resetBtn.addEventListener("click", () => {
    selectedProducts.clear();
    productSelectors.forEach((selector) => {
      const input = selector.querySelector("input");
      input.value = "0";
      input.removeAttribute("disabled");
    });
    addToCartBtn.setAttribute("disabled", "true");
  });

  // ✅ Auto-seleccionar producto al entrar desde PDP
  const variantId = sessionStorage.getItem('initial_bundle_variant');
  if (variantId) {
    const productCard = document.querySelector(`.best-seller-item[data-variant-id="${variantId}"]`);
    if (productCard) {
      const addButton = productCard.querySelector('.add-to-crate');
      if (addButton) {
        addButton.click(); // Simula clic para añadir automáticamente
      }
    }
    sessionStorage.removeItem('initial_bundle_variant');
  }
});
// ✅ Auto-seleccionar producto si se llega desde la PDP
const variantId = sessionStorage.getItem('initial_bundle_variant');
if (variantId) {
  const interval = setInterval(() => {
    const productCard = document.querySelector(`.best-seller-item[data-variant-id="${variantId}"]`);
    if (productCard) {
      const addButton = productCard.querySelector('.add-to-crate');
      if (addButton) {
        addButton.click(); // Simula clic
        clearInterval(interval); // Ya no hace falta seguir buscando
        sessionStorage.removeItem('initial_bundle_variant'); // Limpia el storage
      }
    }
  }, 300);
}

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
